module.exports = __webpack_public_path__ + "static/media/17_after.c8fae449.jpg";